import React from "react";
import { Spinner } from "react-bootstrap"

const SpinnerText = ({ text }) => {
    return <>
        <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        className="me-2"
        />
        {text}
    </>
}
export default SpinnerText;